/**
 * Three-Pillar Color System (SF-63)
 *
 * Consistent colors for Economy, Military, and Science pillars
 * used throughout the Council page redesign.
 */

export const PILLAR_COLORS = {
  economy: {
    primary: '#c4a060',
    dim: '#c4a06040',
    background: '#1a1810',
    border: '#302820',
  },
  military: {
    primary: '#b85a4a',
    dim: '#b85a4a40',
    background: '#1a1210',
    border: '#302020',
  },
  science: {
    primary: '#6a9e8e',
    dim: '#6a9e8e40',
    background: '#101814',
    border: '#1e3028',
  },
} as const;

export type PillarType = keyof typeof PILLAR_COLORS;
